import { Utils } from "@/plugins/utils"
import moment from "moment"

export default {
	namespaced: true,
	state: {
		lstOfy: [],
		ofy: {},
		insert: false,
		update: false,
		loading: false,
		itemsPerPage: 20,
		search: "",
		hasNext: false,
		sinceEnt: moment().format("YYYY-MM-DD 00:00"),
		untilEnt: moment().format("YYYY-MM-DD 23:59"),
		lastUpdatedRegister: null,
	},
	getters: {
		getUpdate(state) {
			return state.update
		},
		getOfy(state) {
			let ofy = { ...state.ofy }
			return ofy
		},
		getOfyid(state) {
			return state.ofy.ofyid
		},
		getSearch(state) {
			return state.search
		},
		getItemsPerPage(state) {
			return state.itemsPerPage
		},
	},
	mutations: {
		set(state, ofy) {
			state.ofy = {...ofy}
			if (ofy) state.update = true
		},
		initForm(state) {
			state.insert = false
			state.update = false
			state.ofy = {}
		},
		setParamsDataTable(state, payload) {
			state.lstOfy = payload.items
			state.itemsPerPage = payload.limit
			state.hasNext = payload.hasNext
		},
		setLoading(state, loading) {
			state.loading = loading
		},
		setOfy(state, ofy) {
			state.ofy = ofy
		},
		setLstOfy(state, lstOfy) {
			state.lstOfy = lstOfy
		},
		setHasNext(state, hasNext) {
			state.hasNext = hasNext
		},
		setSearch(state, search) {
			state.search = search
		},
		setLastUpdatedRegister(state, lastUpdatedRegister) {
			state.lastUpdatedRegister = lastUpdatedRegister
		},
	},
	actions: {
		initForm({ commit }) {
			commit("initForm")
		},
		async search({ commit, getters, dispatch, state }, { limit = 20, page = 1 }) {
			commit("setLoading", true)
			commit("initForm")

			let url = `/OryxPlace/QualityControl/Search?search=${getters.getSearch}&limit=${limit}&page=${page}`

			if (state.sinceEnt) {
				url += `&sinceEnt=${state.sinceEnt}`
			}
			if (state.untilEnt) {
				url += `&untilEnt=${state.untilEnt}`
			}

			let payload = await this._vm.$axios
				.get(url)
				.then(response => {
					let payload = Utils.ValidateAxiosResponse(response.data)
					commit("setParamsDataTable", payload)
					return true
				})
				.catch(error => {
					commit("setLstOfy", [])
					commit("setSearch", "")
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			commit("setLoading", false)
			return payload
		},
		async searchOFYFromOF1({ commit, getters, dispatch }, { limit = 20, page = 1 }) {
			commit("setLoading", true)
			commit("initForm")
			let payload = await this._vm.$axios
				.get(`/OryxPlace/QualityControl/Search?search=${getters.getSearch}&limit=${limit}&page=${page}`)
				.then(response => {
					let payload = Utils.ValidateAxiosResponse(response.data)
					commit("setParamsDataTable", payload)
					return true
				})
				.catch(error => {
					commit("setLstOfy", [])
					commit("setSearch", "")
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			commit("setLoading", false)
			return payload
		},
		async find({ commit, dispatch, state }, ofyid) {
			commit("setLoading", true)
			commit("initForm")
			const response = await this._vm.$axios
				.get(`/OryxPlace/QualityControl/Find/${ofyid}`)
				.then(response => {
					let ofy = Utils.ValidateAxiosResponse(response.data)
					commit("set", ofy)
					return ofy
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
				})
			commit("setLoading", false)
			return response
		},
		async findAnalysis({ commit, dispatch }, ofy) {
            commit("setLoading", true)

            try {
				const response = await this._vm.$axios.get(
				`/OryxPlace/QualityControl/FindAnalysis`,
				{
					params: ofy
				}
			)

                const analysis = Utils.ValidateAxiosResponse(response.data)

                return analysis
            }
            catch (error) {
                dispatch(
                "parameters/openDialog",
                {
                    titleText: "Erro",
                    titleColor: "red",
                    text: error.message,
                },
                { root: true }
                )

                return null  
            }
            finally {
                commit("setLoading", false)
            }
        },
		async get({ dispatch }, ofyid) {
			return await this._vm.$axios
				.get(`/OryxPlace/QualityControl/Find/${ofyid}`)
				.then(response => {
					return Utils.ValidateAxiosResponse(response.data)
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return null
				})
		},
		async getOf2lotemp({ dispatch }, of2lotemp) {
			return await this._vm.$axios
				.get(`/OryxPlace/QualityControl/FindOf2lotemp/${of2lotemp}`)
				.then(response => {
					return Utils.ValidateAxiosResponse(response.data)
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return null
				})
		},
		async save({ getters, dispatch }, model) {
			if (getters.getUpdate) {
				return await dispatch("update", model)
			}
			return await dispatch("insert", model)
		},
		async insert({ commit, dispatch, state }, model) {
			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Salvando", indeterminate: true },
				{ root: true },
			)
			let payload = await this._vm.$axios
			.post(`/OryxPlace/QualityControl/Insert?validDc1=${model.validDc1}`, model.ofy)
				.then(response => {
					let ofy = Utils.ValidateAxiosResponse(response.data)
					commit("setLastUpdatedRegister", ofy)
					commit("setOfy", ofy)
					state.update = true
					return response.data ? response.data : false
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
		async update({ commit, getters, dispatch }, model) {
			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Salvando", indeterminate: true },
				{ root: true },
			)
			let payload = await this._vm.$axios
				.put(`/OryxPlace/QualityControl/Update?validDc1=${model.validDc1}`, getters.getOfy)
				.then(response => {
					let ofy = Utils.ValidateAxiosResponse(response.data)
					commit("setLastUpdatedRegister", ofy)
					return true
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
		async conclude({ commit, dispatch }, model) {
			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Concluindo", indeterminate: true },
				{ root: true },
			)
			let payload = await this._vm.$axios
				.post(`/OryxPlace/QualityControl/Conclude?validDc1=${model.validDc1}`, model.ofy)
				.then(response => {
					let ofy = Utils.ValidateAxiosResponse(response.data)
					commit("setLastUpdatedRegister", ofy)
					commit("setOfy", ofy)
					return ofy
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},

		async delete({ getters, dispatch }) {
			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Excluindo", indeterminate: true },
				{ root: true },
			)

			const result = await this._vm.$axios
				.delete(`/OryxPlace/QualityControl/Delete/${getters.getOfyid}`)
				.then(response => {
					Utils.ValidateAxiosResponse(response.data)
					return true
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})

			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: false, text: "" },
				{ root: true },
			)

			return result
		},
		convertDatesToISO(obj) {
			const dateFields = ["ofyent", "ofyfabric", "ofyvalid"]
			return Object.keys(obj).reduce((acc, key) => {
				acc[key] = dateFields.includes(key) && obj[key] ? new Date(obj[key]).toISOString() : obj[key]
				return acc
			}, {})
		},
		async printMaterialReception(store, model) {
			store.dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Imprimindo relatório", indeterminate: true },
				{ root: true },
			)
			let payload = await this._vm.$axios
				.post(`/OryxPlace/QualityControl/PrintMaterialReception`, model)
				.then(response => {
					let relatPath = Utils.ValidateAxiosResponse(response.data)
					if (relatPath) {
						store.dispatch("print/openRelatsPath", [relatPath], { root: true })
					}
					return true
				})
				.catch(error => {
					store.dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
	},
}
